import confetti from 'canvas-confetti';

type Shape = ReturnType<typeof confetti.shapeFromPath>;

// Celebration (design law § Celebration): falling LOOSE BARS — small rounded
// bars in the brand + governed habit hues, classic confetti energy without
// logo silhouettes and without stock canvas-confetti defaults. User-approved
// against a live prototype 2026-07-09 (chosen over the color wave, which read
// poorly on screen, and over the earlier 3-bar logo-mark confetti).
// Rare/first-time motion-budget tier only (routine completion, streak
// milestones). Callers own the reduced-motion guard.

// Rounded-bar subpath: width w, height 5, full caps.
function bar(w: number): string {
  return `M2.5 0 h${w - 5} a2.5 2.5 0 0 1 0 5 h-${w - 5} a2.5 2.5 0 0 1 0 -5 z`;
}

// Built lazily: shapeFromPath needs Path2D (absent in jsdom, where the module
// is mocked anyway) — on failure we fall back to stock shapes in brand colors.
let cachedShapes: Shape[] | null | undefined;

function shapes(): Shape[] | undefined {
  if (cachedShapes === undefined) {
    try {
      cachedShapes = [
        confetti.shapeFromPath({ path: bar(24) }),
        confetti.shapeFromPath({ path: bar(16) }),
      ];
    } catch {
      cachedShapes = null;
    }
  }
  return cachedShapes ?? undefined;
}

// Brand iris + the governed habit palette. Literal light-theme values — the
// confetti canvas can't resolve CSS vars, and these hues read on both themes.
const BAR_COLORS = ['#5b50cc', '#b05c34', '#a1811f', '#6d8340', '#2f7f8d', '#8d5399'];

export function celebrateBurst(): void {
  const s = shapes();
  void confetti({
    colors: BAR_COLORS,
    ...(s ? { shapes: s, scalar: 1.15 } : {}),
    // Gentler-than-stock physics, tuned in the approved prototype: a soft
    // burst that settles quickly rather than an explosion.
    particleCount: 60,
    spread: 75,
    startVelocity: 32,
    gravity: 0.85,
    decay: 0.92,
    ticks: 200,
    origin: { x: 0.5, y: 0.62 },
  });
}
